/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shop_Home_Hero_NoteInputs */

const vi_shop_home_hero_note = /** @type {(inputs: Shop_Home_Hero_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Slide hiện ở một kênh khi: Bật + trong lịch + có cờ kênh. Không còn slide nào hiện → web dùng 4 slide mặc định; Mini App ẩn slider.`)
};

/**

* @param {Shop_Home_Hero_NoteInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const shop_home_hero_note = /** @type {((inputs?: Shop_Home_Hero_NoteInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shop_Home_Hero_NoteInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_shop_home_hero_note(inputs)
});